class SaveState {
  constructor () {
    this.icon = '';
    this.text = '';
    this.canSave = false;
    this.canFork = false;
    this.canDelete = false;
  }
}

export default SaveState;